import React from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {LogsModuleIcon, CircleIcon} from '@src/assets/icons'

export const logNavigation =  [
    {
        id: 'logModule',
        title: 'log.nav.logs',
        icon: <FontAwesomeIcon icon={LogsModuleIcon}/>,
        children: [
            {
                id: 'logMyActivity',
                title: 'log.nav.myActivity',
                icon: <FontAwesomeIcon icon={CircleIcon}/>,
                navLink: '/log/activity-log',
                action: 'call',
                resource: 'LOG_VIEW_MY_ACTIVITY'
            },
            {
                id: 'logUserActivity',
                title: 'log.nav.userActivity',
                icon: <FontAwesomeIcon icon={CircleIcon}/>,
                navLink: '/log/user-activity-log',
                action: 'call',
                resource: 'LOG_VIEW_USER_ACTIVITY'
            },
            {
                id: 'logActivityTypes',
                title: 'log.nav.activityTypes',
                icon: <FontAwesomeIcon icon={CircleIcon}/>,
                navLink: '/log/activity-types',
                action: 'call',
                resource: 'LOG_VIEW_ACTIVITY_TYPES'
            }
        ]
    }
]
